const EXPORT_STRINGS = {
  // Modal
  MODAL_TITLE: "Timecard Exports",
  CLOSE_ALT: "Close",

  // Section Headers
  SECTION_EMPLOYEE_TIMECARDS: "Employee Timecards",
  SECTION_ADP: "ADP",
  SECTION_ADJUSTMENT_SUMMARY: "Adjustment Summary",
  SECTION_AUDIT_SUMMARY: "Audit Summary",
  SECTION_DATA_TECH: "Data Tech",
  SECTION_FENCE_FACTORY: "Fence Factory",
  SECTION_ISOLVED: "iSolved",
  SECTION_JOB_COSTING_DETAIL: "Job Costing Payroll Detail",
  SECTION_JOB_COSTING_SUMMARY: "Job Costing Payroll Summary",
  SECTION_MEAL_SURVEY: "Meal Survey Export",
  SECTION_PAYCHEX: "Paychex",
  SECTION_PAYLOCITY: "Paylocity",
  SECTION_PTO_BALANCE: "PTO Balance",
  SECTION_QUICKBOOKS: "Quickbooks",
  SECTION_SAGE: "SAGE",
  SECTION_SDP_PAYROLL: "SDP Payroll",
  SECTION_SDP_REIMBURSEMENT: "SDP Reimbursement",
  SECTION_SOUTHEAST_PAYROLL: "Southeast Payroll",
  SECTION_VIEWPOINT: "Viewpoint",
  SECTION_FAMOUS_EXPORT: "Famous Export",
  SECTION_MMCHR_EXPORT: "MMCHR Export",
  SECTION_QBD_MAX_TIME: "QBD Max Time Export",
  SECTION_ADP_CUSTOM: "ADP Custom Export",
  SECTION_QBD_TAG: "QBD Tag Export",
  SECTION_WAMS: "WAMS Timecard Export",
  SECTION_AUTOMATE_CSV: "Automate CSV",
  SECTION_FLSA: "FLSA Export",

  // Export Button Labels
  BTN_EXPORT_PDF: "EXPORT PDF",
  BTN_EXPORT_PDF_2: "EXPORT PDF 2",
  BTN_EXPORT_XLS: "EXPORT XLS",
  BTN_EXPORT_XLS_2: "EXPORT XLS 2",
  BTN_EXPORT_XLS_3: "EXPORT XLS 3",
  BTN_EXPORT_CSV: "EXPORT CSV",
  BTN_EXPORT_CSV_2: "EXPORT CSV 2",
  BTN_EXPORT_IIF: "EXPORT IIF",
  BTN_EXPORT_IIF_2: "EXPORT IIF 2",
  BTN_EXPORT_ASCII: "EXPORT ASCII",
  BTN_EXPORT_MMCHR: "EXPORT MMCHR",
  BTN_EXPORT_QBD: "EXPORT QBD",

  // Checkbox Labels
  CHECKBOX_CORRECTION_REQUEST: "Include Correction Requests",
  CHECKBOX_DAYS_NOT_WORKED: "Include Days Not Worked",
  CHECKBOX_SHIFT_NAME: "Include Shift Name",
  CHECKBOX_ORG_INFO: "Include Org Info",
  CHECKBOX_HIDE_DECIMAL: "Hide Decimal Conversion Totals",
  CHECKBOX_HIDE_HH_MM: "Hide HH:MM Conversion Totals",
  CHECKBOX_INCLUDE_PAGE_NUMBER: "Include Page Number",
  CHECKBOX_SUPERVISOR_SIGNATURE: "Add Supervisor Signature",
  CHECKBOX_SHOW_WEEKLY_TOTALS: "Show Weekly Totals",
  CHECKBOX_HIDE_DOUBLE_OT: "Hide Double OT Column",
  CHECKBOX_INCLUDE_CORRECTIONS: "Include Corrections",
  CHECKBOX_INCLUDE_JOB_NOTES: "Include Job Notes",
  CHECKBOX_HANDLE_MAX_PAID_TIME: "Handle Max Paid Time",

  // Audit Columns Dropdown
  DROPDOWN_TITLE_SHOW_HIDE: "Show/Hide Columns",
  BTN_APPLY: "Apply",

  // Audit Column Names (mandatory)
  COL_FIRST_NAME: "First Name",
  COL_LAST_NAME: "Last Name",
  COL_EMPLOYEE_ID: "Employee ID",
  COL_RT: "RT",
  COL_OT: "OT",
  COL_DT: "DT",
  COL_TOTAL_PAID: "Total Paid",

  // Audit Column Names (optional)
  COL_EMPLOYEE_TITLE: "Employee Title",
  COL_DAYS_WORKED: "Days Worked",
  COL_PUNCH_IN_TIME: "Punch-in Time",
  COL_MEAL_PERIOD_TIME: "Meal Period Time",
  COL_WORKED_TIME: "Worked Time",

  // QBD Max Time Export
  LABEL_HR: "Hr",

  // ADP Custom Export
  LABEL_BATCH_ID: "Batch ID",
  PLACEHOLDER_BATCH_ID: "Enter Batch ID",
  ERROR_BATCH_ID: "Batch ID should be positive six digit number.",

  // Toast / Validation
  ERROR_SELECT_FORMAT: "Please select the file type to export",

  // Errors / Logs
  ERROR_FETCH_ADJUSTMENT_TYPES: "Failed to fetch adjustment types:",
  ERROR_FETCH_PTO_POLICIES: "Error fetching pto policy list",

  // Cookie Key
  COOKIE_EXPORT_FORMAT: "exportSelectedFormat",
  COOKIE_HIDE_DECIMAL: "isHideDecimalConversion",

  // Section Headers (missing ones)
  SECTION_WAMS_FULL: "WAMS CSV Timecard Export", // if needed

  // Export Button Labels (missing ones)
  BTN_EXPORT_PDF_2: "EXPORT PDF 2", // already there
  BTN_EXPORT_CSV_2: "EXPORT CSV 2", // already there

  // Format Keys (for selectStandardFormat & submit mapping)
  FORMAT_CSV: "csv",
  FORMAT_PAYCHEX2: "paychex2",
  FORMAT_DATA_TECH_CSV: "dataTechcsv",
  FORMAT_IIF: "iif",
  FORMAT_IIF2: "iif2",
  FORMAT_IIF_MAX: "iif_max",
  FORMAT_FLSA: "flsa",
  FORMAT_WAMS_CSV: "wams_csv",
  FORMAT_CUSTOM_TIMECARD_CSV: "custom_timecard_csv",
  FORMAT_QBD_TAG: "qbd-tag",
  FORMAT_CUSTOM_ADP: "custom_adp",
  FORMAT_JOB_COSTING_XLS: "jobCostingXls",
  FORMAT_JOB_COSTING_PDF: "jobCostingPdf",
  FORMAT_JOB_COSTING_PDF2: "jobCostingPdf2",
  FORMAT_JOB_COSTING_DETAIL_XLS: "jobCostingDetailXls",
  FORMAT_JOB_COSTING_DETAIL_PDF: "jobCostingDetailPdf",
  FORMAT_JOB_COSTING_DETAIL_PDF2: "jobCostingDetailPdf2",
  FORMAT_ADP_XLS: "ADPXls",
  FORMAT_ADP_XLS2: "ADPXls2",
  FORMAT_PAY_DATA_CSV: "payDatacsv",
  FORMAT_MILEAGE_CSV: "mileagecsv",
  FORMAT_SOUTH_EAST_CSV: "southEastCsv",
  FORMAT_AUDIT_XLS: "auditXls",
  FORMAT_AUDIT_XLS2: "auditXls2",
  FORMAT_AUDIT_XLS3: "auditXls3",
  FORMAT_AUDIT_PDF: "auditPDF",
  FORMAT_ADJUSTMENT_XLS: "adjustmentXls",
  FORMAT_SAGE_CSV: "sageExportcsv",
  FORMAT_ISOLVED_CSV: "iSolvedCsv",
  FORMAT_ISOLVED_XLS: "iSolvedXls",
  FORMAT_MIKE_ROVNER_CSV: "mikerovnercsv",
  FORMAT_MEALS_FLAG: "mealsFlagExport",
  FORMAT_FENCE_FACTORY_XLS: "fenceFactoryXls",
  FORMAT_PTO_BALANCE_CSV: "ptoBalanceCsv",
  FORMAT_PAYLOCITY_CSV: "paylocityCsv",
  FORMAT_FAMOUS_EXPORT: "famousexporttxt",
  FORMAT_MMCHR: "mmchrExport",
  FORMAT_PDF: "pdf",
  FORMAT_XLS: "xls",
};

export default EXPORT_STRINGS;
